import FetchHelpers from "../fetch-helpers";

document.addEventListener('DOMContentLoaded', async (e) => {
  await loadContent();
});

/**
 *  Update CW List accordion contents.
 *
 * @returns {Promise<void>}
 */
async function loadContent() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

          if ('t' in params && 's' in params) {
    // if ('s' in params && ('r' in params || 'v' in params)) {
    let data = {
      'pub_type': params.t ?? '',
      'stub': params.s ?? '',
      'range': params.r ?? '',
      'volume': params.v ?? '',
      'title': params.l ?? ''
    }
    // }

    let f = new FetchHelpers().fetchData;

    let url = '';
    let scheme = 'http://';
    if (document.referrer.includes('org')) {
      scheme = 'https://';
    }

    url = scheme + parseUrl(document.referrer) + '/books/fetch/cw-list-content.php';

    jQuery(document).foundation();
    await closeAllButMarked();

    let response = await f('POST', url, data);

    // Open level-1 accordion
    let mainAccordion = jQuery('#sets-accordion');
    mainAccordion.foundation('down', jQuery(`div#${response['range']}.accordion-content`));

    let insertion_point = document.querySelector(`[data-range="${response['range']}"].accordion-item`);
    let accordion_content = insertion_point.querySelector('.accordion-content');

    // inject fetched content
    accordion_content.innerHTML = response['accordion-content'];

    if (response['error']) {
      accordion_content.dataset.loaded = 'false';
    } else {
      accordion_content.dataset.loaded = 'true';
    }

    // reload foundation elements after injection
    jQuery(document).foundation();
  }
}

function parseUrl(url) {
  let a = document.createElement('a');
  a.href=url;
  return a.hostname;
}

async function closeAllButMarked(pub_type) {
  jQuery('#sets-accordion').each(function () {
    let acc = jQuery(this);
    let openSections = acc.find('.accordion-item.is-active .accordion-content');
    openSections.each(function (i, section) {
      if(section.parentElement.dataset.hasOwnProperty('markerFromReader')) {
        if(pub_type === 'CWWL') {
          acc.foundation('down', jQuery(section));
        }
      } else {
        acc.foundation('up', jQuery(section));
      }
    });
  });
}
